import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import SEO from "../components/SEO";

export default function PrivacyPolicy() {

  return (
    <>
      <SEO
        title="Privacy Policy - Online Tools Center"
        description="Read the privacy policy of Online Tools Center regarding cookies, analytics, and data usage."
        keywords="privacy policy, cookies policy, data usage"
        url="https://online-tools-center.vercel.app/privacy-policy"
      />

      <Navbar />

      {/* HERO */}

      <section
        style={{
          background:
            "linear-gradient(135deg,#0f172a,#1e293b)",
          color: "white",
          padding:
            "70px 20px",
        }}
      >

        <div className="container text-center">

          <h1
            className="fw-bold mb-3"
            style={{
              fontSize:
                "clamp(2.5rem,5vw,4rem)",
            }}
          >
            Privacy Policy
          </h1>

          <p
            className="lead mx-auto"
            style={{
              maxWidth: "800px",
            }}
          >
            Learn how we collect,
            use,
            and protect your information
            while using our website.
          </p>

        </div>

      </section>

      {/* CONTENT */}

      <div className="container py-5">

        <div
          className="card border-0 shadow-lg rounded-4 p-4 p-md-5"
        >

          <p className="text-muted">
            Last Updated:
            {" "}
            {new Date().getFullYear()}
          </p>

          <h2 className="fw-bold mt-4">
            Introduction
          </h2>

          <p className="text-muted">
            Online Tools Center values
            your privacy and is committed
            to protecting your information.
            This Privacy Policy explains
            how our website collects,
            uses,
            and safeguards data.
          </p>

          <h2 className="fw-bold mt-5">
            Information We Collect
          </h2>

          <p className="text-muted">
            We may collect limited
            non-personal information such as:
          </p>

          <ul className="text-muted">

            <li>
              Browser type
            </li>

            <li>
              Device information
            </li>

            <li>
              Anonymous analytics data
            </li>

            <li>
              Website usage statistics
            </li>

          </ul>

          <h2 className="fw-bold mt-5">
            Cookies
          </h2>

          <p className="text-muted">
            Our website may use cookies
            to improve user experience,
            analyze traffic,
            and serve advertisements.
          </p>

          <h2 className="fw-bold mt-5">
            Google AdSense
          </h2>

          <p className="text-muted">
            We may use Google AdSense
            to display advertisements.
            Google may use cookies
            to personalize ads
            based on user interests.
          </p>

          <h2 className="fw-bold mt-5">
            Third-Party Services
          </h2>

          <p className="text-muted">
            We may use trusted third-party
            services including:
          </p>

          <ul className="text-muted">

            <li>
              Google Analytics
            </li>

            <li>
              Google AdSense
            </li>

            <li>
              Vercel Hosting
            </li>

          </ul>

          <h2 className="fw-bold mt-5">
            Data Security
          </h2>

          <p className="text-muted">
            We take reasonable measures
            to protect user information.
            Many tools on this website
            process data directly
            inside your browser.
          </p>

          <h2 className="fw-bold mt-5">
            External Links
          </h2>

          <p className="text-muted">
            Our website may contain links
            to external websites.
            We are not responsible
            for third-party privacy practices.
          </p>

          <h2 className="fw-bold mt-5">
            Contact Us
          </h2>

          <p className="text-muted">
            For privacy-related questions,
            contact:
          </p>

          <div
            className="alert alert-primary"
          >
            emicalculator.official@gmail.com
          </div>

        </div>

      </div>

      <Footer />

    </>
  );
}